(ns quuppa.utils
  (:require [clojure.string :as str]
            #?@(:cljs [[goog.string :as gstring]
                       goog.string.format
                       ["@js-joda/core" :refer [LocalDate]]]))
  #?(:clj (:import (java.time LocalDate))))

; all special characters after space and letters till tilde
(defn rand-str [len]
  (apply str (take len (repeatedly #(char (+ (rand 48) 42))))))

(defn remove-nils [m]
  (into {} (remove (comp nil? second) m)))

;; TODO: Move to domain utils ns
(defn channel->pretty-string [^long chan]
  (case chan
    37 "BLE"
    230 "Proprietary"
    150 "Proprietary2401"
    152 "Proprietary2403"
    nil))

(defn str-format
  "Clojure/Script convenience wrapper for string format.
  `clojure.core/format` in Clojure, `goog.string/format` in ClojureScript."
  [s & args]
  ;; Use dots for decimal separator always.
  ;; goog.string.format isn't locale aware, so it will use dot always.
  #?(:clj  (String/format (java.util.Locale/forLanguageTag "en-US") s (into-array Object args))
     :cljs (apply gstring/format s args)))

(defn format-bytes
  "Convert the number measured in bytes to KB, MB, GB, and TB. Returns a string."
  #_{:clj-kondo/ignore [:shadowed-var]}
  [bytes]
  (if bytes
    (cond
      (> bytes (* 1024 1024 1024 1024)) (str (str-format "%.2f" (double (/ bytes (* 1024 1024 1024 1024)))) " TB")
      (> bytes (* 1024 1024 1024)) (str (str-format "%.2f" (double (/ bytes (* 1024 1024 1024)))) " GB")
      (> bytes (* 1024 1024)) (str (str-format "%.2f" (double (/ bytes (* 1024 1024)))) " MB")
      (> bytes 1024) (str (str-format "%.2f" (double (/ bytes 1024))) " KB")
      :else (str (str-format "%d" bytes) " B"))
    ""))

;; TODO: Remove or rename
;; "for-log-table" is not useful utility fn.
(defn format-bytes-for-log-table
  "Convert bytes to KB, MB, etc. With colors. For Log Table"
  #_{:clj-kondo/ignore [:shadowed-var]}
  [bytes]
  (cond
    (> bytes (* 1024 1024)) [:span {:style {:color "red"}} (str (quot bytes (* 1024 1024)) " MB")]
    (> bytes 1024) [:span {:style {:color "orange"}} (str (quot bytes 1024) " KB")]
    :else (str bytes " B")))

(defn parse-date
  [s]
  (when s
    (. LocalDate parse s)))

;; Number class function will parse numbers in JS.
;; Difference to parseInt and parseFloat is that
;; this fn doesn't allow extra input, i.e. "123 foo".

(defn parse-int
  "Parse an integer.

  Doesn't allow extra input.
  Doesn't allow infinity values (not supported by JVM Long)."
  [s]
  #?(:cljs (when (re-matches #"^[-+]?(\d+)$" s)
             (let [n (js/Number s)]
               (when-not (js/isNaN n)
                 n)))
     :clj  (try
             (Long/parseLong s)
             (catch NumberFormatException _
               nil))))

(defn parse-number
  "Parse a floating point number.

  Allow both . or , as decimal separator.
  Doesn't allow thousand separators.
  Doesn't allow extra input.
  Does allow infinity values."
  [s]
  (let [s (str/replace s #"," ".")]
    #?(:cljs
       (when (re-matches #"^[-+]?([\d.]+|Infinity)$" s)
         (let [n (js/Number s)]
           (when-not (js/isNaN n)
             n)))
       :clj
       (try
         (Double/parseDouble s)
         (catch NumberFormatException _
           nil)))))

(defn parse-user-number
  "Parses a (floating point) number from user input.

  Will trim whitespace from the value first."
  [s]
  (parse-number (str/trim s)))

(defn radians->degrees [rad]
  (* rad (/ 180 Math/PI)))

(defn degrees->radians [degrees]
  (* degrees (/ Math/PI 180)))

; i.e. normalize angle, same as in commons.math.MathUtils.normalizeAngle
(defn mod-pi [angle]
  (Math/atan2 (Math/sin angle) (Math/cos angle)))

;; found this semi-simple looking regex from https://urlregex.com/index.html
;; some other interesting found was https://mathiasbynens.be/demo/url-regex :D
(def https-pattern (re-pattern "([\\s\\S]*?)(https?://[-a-zA-Z0-9+&@#/%?=~_|!:,.;]*[-a-zA-Z0-9+&@#/%=~_|])([\\s\\S]*)"))
;; Juhos version which inspired the use of capture groups and initially contained 'www' support.
;; (def URL-RE #"([\\s\\S]*?)((?:https?):\/\/(?:(?:[a-z0-9.-]|%[0-9A-F]{2}){3,})(?::\d+)?(?:(?:\/(?:[a-z0-9-._~!$&'()*+,;=:@]|%[0-9A-F]{2})*)*)(?:\?(?:(?:[a-z0-9-._~!$&'()*+,;=:\/?@]|%[0-9A-F]{2})*))?(?:#(?:(?:[a-z0-9-._~!$&'()*+,;=:\/?@]|%[0-9A-F]{2})*))?)(.*)")

#?(:cljs
   (defn stop-propagation [evt]
     (.stopPropagation evt)))

(defn hiccup-linkify
  "Takes a string, and wraps all http(s) URLs by default with [:a] tag.
  The string itself and the anchor tags are wrapped into React.Fragment (:<>).
  You can also provide your own URL wrapper function as second param. It is called with regex matched URL string."
  ([s]
   (hiccup-linkify s
                   (fn [link]
                     [:a
                      (merge {:href link}
                             #?(:cljs {:on-click stop-propagation}
                                :clj nil))
                      link])))
  ([s wrapper]
   (loop [s s
          html [:<>]]
     (if-let [[_ a b rst] (and s (re-find https-pattern s))]
       (recur rst
              (-> html
                  (conj a)
                  (conj (wrapper b))))
       (if (seq s)
         (conj html s)
         html)))))

(defn empty-string? [s]
  (empty? (str/trim s)))

(defn duplicate-string? [old-str new-str]
  (= (str/trim old-str) (str/trim new-str)))
